import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import css from "./TitleMenuMessage.module.css";
import { Tabs } from "antd";
import { useRoleAccess } from "../../../hooks/useRoleAccess";
import { getTitleMenuMessage } from "../../../helpers/getTitleMenuMessage";

function TitleMenuMessage() {
  const { t } = useTranslation();

  const { userRole } = useRoleAccess();
  const listTitleMenu = getTitleMenuMessage(t, userRole);
  return (
    <nav className={css.wrap}>
      <Tabs
        defaultActiveKey="1"
        tabPlacement="top"
        items={listTitleMenu.map(({ name, linkForRoute, allowedRoles }) => ({
          label: allowedRoles ? (
            <NavLink
              to={`/messages/${linkForRoute.toLowerCase()}`}
              className={({ isActive }) =>
                `${css.menuItem} ${isActive ? css.active : ""}`
              }
            >
              <span className={css.menuText}>{name}</span>
            </NavLink>
          ) : null,
          key: linkForRoute,
        }))}
      />
      {/* <ul className={css.ul}>
      {listTitleMenu.map(({ name, linkForRoute }) => (
        <li key={name}>
          <NavLink
            to={`/settings/${linkForRoute.toLowerCase()}`}
            className={({ isActive }) =>
              `${css.menuItem} ${isActive ? css.active : ""}`
            }
          >
            <span className={css.menuText}>{name}</span>
          </NavLink>
        </li>
      ))}
    </ul> */}
    </nav>
  );
}

export default TitleMenuMessage;
